import type { AuthSession } from '@logistech/ui-shared';

import { useAuth } from '@/store/auth';

export type Role = AuthSession['user']['role'];

// Rôles attribuables par invitation ou changement de rôle (enum Zod des routes users du tenants-service)
export const ASSIGNABLE_ROLES = ['OWNER', 'ADMIN', 'MANAGER', 'DISPATCHER', 'DRIVER', 'ACCOUNTANT', 'VIEWER'] as const;
export type AssignableRole = (typeof ASSIGNABLE_ROLES)[number];

// Miroir de canManageRole (packages/auth/src/permissions.ts, FINDING-016) : le paquet auth est côté serveur,
// l'API reste seule juge. Seul un OWNER attribue, modifie ou retire le rôle OWNER.
export const canManageRole = (actorRole: Role | undefined, role: Role): boolean =>
  role !== 'OWNER' || actorRole === 'OWNER';

export const useCanManageRole = (targetRole: Role): boolean => {
  const role = useAuth((s) => s.session?.user.role);
  return canManageRole(role, targetRole);
};

/** Rôles que l'utilisateur courant peut attribuer (un ADMIN ne voit pas OWNER). */
export const useAssignableRoles = (): AssignableRole[] => {
  const role = useAuth((s) => s.session?.user.role);
  return ASSIGNABLE_ROLES.filter((r) => canManageRole(role, r));
};
